import {
  SortingCriterionEnum,
  SortingCriterionLabelEnum,
} from 'app/shared/enums';
import { Dictionary } from 'app/services/dict.service';

export const sortingCriterionDictionary: Dictionary<{
  key: SortingCriterionEnum;
  value: SortingCriterionLabelEnum;
}> = [
  {
    key: SortingCriterionEnum.PriceAsc,
    value: SortingCriterionLabelEnum.SortFromCheapest,
  },
  {
    key: SortingCriterionEnum.PriceDesc,
    value: SortingCriterionLabelEnum.SortFromMostExpensive,
  },
  {
    key: SortingCriterionEnum.InsurerAsc,
    value: SortingCriterionLabelEnum.InsurerAscending,
  },
  {
    key: SortingCriterionEnum.InsurerDesc,
    value: SortingCriterionLabelEnum.InsurerDescending,
  },
];

export const sortingCriterionDictionaryMobile: Dictionary<{
  key: SortingCriterionEnum;
  value: SortingCriterionLabelEnum;
}> = [
  {
    key: SortingCriterionEnum.PriceAsc,
    value: SortingCriterionLabelEnum.FromCheapest,
  },
  {
    key: SortingCriterionEnum.PriceDesc,
    value: SortingCriterionLabelEnum.FromMostExpensive,
  },
  {
    key: SortingCriterionEnum.InsurerAsc,
    value: SortingCriterionLabelEnum.InsurerAscending,
  },
  {
    key: SortingCriterionEnum.InsurerDesc,
    value: SortingCriterionLabelEnum.InsurerDescending,
  },
];

export const sortingCriterionDictionaryTravel: Dictionary<{
  key: SortingCriterionEnum;
  value: SortingCriterionLabelEnum;
  valueShort: SortingCriterionLabelEnum;
}> = [
  {
    key: SortingCriterionEnum.PriceAsc,
    value: SortingCriterionLabelEnum.SortFromCheapest,
    valueShort: SortingCriterionLabelEnum.FromCheapestShort,
  },
  {
    key: SortingCriterionEnum.PriceDesc,
    value: SortingCriterionLabelEnum.SortFromMostExpensive,
    valueShort: SortingCriterionLabelEnum.FromMostExpensiveShort,
  },
  {
    key: SortingCriterionEnum.MedicalCostsDesc,
    value: SortingCriterionLabelEnum.MedicalCostsDescending,
    valueShort: SortingCriterionLabelEnum.MedicalCostsDescendingShort,
  },
  {
    key: SortingCriterionEnum.InsurerAsc,
    value: SortingCriterionLabelEnum.InsurerAscending,
    valueShort: SortingCriterionLabelEnum.InsurerAscendingShort,
  },
  {
    key: SortingCriterionEnum.InsurerDesc,
    value: SortingCriterionLabelEnum.InsurerDescending,
    valueShort: SortingCriterionLabelEnum.InsurerDescendingShort,
  },
];
